import { Card, CardContent } from '@/components/ui/card';

/**
 * PmsKpiCard - Compact KPI card for PMS metrics
 * Used in Overview, Reports, and analytics sections
 */

export const PmsKpiCard = ({ 
  title, 
  value, 
  icon: Icon, 
  trend,
  trendLabel,
  subtitle,
  className = '',
  variant = 'default'
}) => {
  const getTrendColor = () => {
    if (!trend) return '';
    if (trend > 0) return 'text-[hsl(var(--status-clean))]';
    if (trend < 0) return 'text-[hsl(var(--status-dirty))]';
    return 'text-muted-foreground';
  };
  
  const getVariantStyle = () => {
    switch (variant) {
      case 'primary':
        return 'border-primary/20 bg-primary/5';
      case 'success':
        return 'border-[hsl(var(--status-clean)/0.2)] bg-[hsl(var(--status-clean)/0.05)]';
      case 'warning':
        return 'border-[hsl(var(--status-maintenance)/0.2)] bg-[hsl(var(--status-maintenance)/0.05)]';
      case 'danger':
        return 'border-[hsl(var(--status-dirty)/0.2)] bg-[hsl(var(--status-dirty)/0.05)]';
      default:
        return '';
    }
  };
  
  return (
    <Card className={`${getVariantStyle()} ${className}`} data-testid={`pms-kpi-${title.toLowerCase().replace(/\s+/g, '-')}`}>
      <CardContent className="p-4">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-1">
              {title}
            </p>
            <p className="text-2xl md:text-3xl font-bold heading-font [font-variant-numeric:tabular-nums]">
              {value}
            </p>
            
            {subtitle && (
              <p className="text-xs text-muted-foreground mt-1">
                {subtitle}
              </p>
            )}
            
            {(trend !== undefined || trendLabel) && (
              <div className="flex items-center gap-1 mt-2">
                {trend !== undefined && (
                  <span className={`text-xs font-medium ${getTrendColor()}`}>
                    {trend > 0 ? '↑' : trend < 0 ? '↓' : '→'} {Math.abs(trend)}%
                  </span>
                )}
                {trendLabel && (
                  <span className="text-xs text-muted-foreground">
                    {trendLabel}
                  </span>
                )}
              </div>
            )}
          </div>
          
          {Icon && (
            <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon className="w-5 h-5 text-primary" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
